/**
 * Languages the Speak AI platform's own UI is translated into — matches the
 * 25 files in src/locales/. Not the same list as the transcription/analysis
 * engine's supported languages (speak-server's LanguageConfigService, ~137
 * languages) — that's what a recording can be transcribed in, this is what
 * the app's own menus and buttons are translated into.
 */
export const PLATFORM_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "es", label: "Español" },
  { code: "pt", label: "Português" },
  { code: "it", label: "Italiano" },
  { code: "nl", label: "Nederlands" },
  { code: "pl", label: "Polski" },
  { code: "ru", label: "Русский" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "zh", label: "中文" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "tr", label: "Türkçe" },
  { code: "sv", label: "Svenska" },
  { code: "fi", label: "Suomi" },
  { code: "nb", label: "Norsk" },
  { code: "el", label: "Ελληνικά" },
  { code: "cs", label: "Čeština" },
  { code: "sk", label: "Slovenčina" },
  { code: "sl", label: "Slovenščina" },
  { code: "uk", label: "Українська" },
  { code: "hu", label: "Magyar" },
  { code: "ca", label: "Català" },
  { code: "he", label: "עברית" },
] as const;
